import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import { SaveRatingRequestPayload, Video } from '../../types'

export const videosApi = createApi({
  reducerPath: 'videosApi',
  baseQuery: baseQueryConfigured,
  endpoints: (builder) => ({
    getVideosByCategory: builder.query<Video[], string>({
      query: (category: string) => ({
        url: `${CONSTANTS.API.VIDEOS}?category=${category}`,
      }),
    }),
    getVideoById: builder.query<Video, string>({
      query: (id: string) => ({
        url: `${CONSTANTS.API.VIDEOS}/${id}`,
      }),
    }),
    saveVideoRating: builder.mutation({
      query: (payload: SaveRatingRequestPayload) => {
        return {
          url: `${CONSTANTS.API.VIDEOS}/${payload.video_id}${CONSTANTS.API.RATINGS}`,
          method: 'POST',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetVideosByCategoryQuery, useGetVideoByIdQuery } = videosApi
